module.exports = __webpack_public_path__ + "static/img/XYZ.3a310972.png";